import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ChangesDiff',
  props: {
    syncState: {
      type: Object,
      required: true
    },
    fund: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var moduleUpdatesLength = computed(function () {
      return props.syncState && props.syncState.moduleUpdates && props.syncState.moduleUpdates.length ? props.syncState.moduleUpdates.length : 0;
    });
    var moduleUpdates = computed(function () {
      return props.syncState && props.syncState.moduleUpdates ? props.syncState.moduleUpdates : [];
    });
    var esgQuestionnairesToAddLength = computed(function () {
      return props.syncState && props.syncState.esgQuestionnairesToAdd && props.syncState.esgQuestionnairesToAdd.length ? props.syncState.esgQuestionnairesToAdd.length : 0;
    });
    var esgQuestionnairesToAdd = computed(function () {
      return props.syncState && props.syncState.esgQuestionnairesToAdd ? props.syncState.esgQuestionnairesToAdd : [];
    });
    var assignmentsToAddLength = computed(function () {
      return props.syncState && props.syncState.assignmentsToAdd && props.syncState.assignmentsToAdd.length ? props.syncState.assignmentsToAdd.length : 0;
    });
    var assignmentsToAdd = computed(function () {
      return props.syncState && props.syncState.assignmentsToAdd ? props.syncState.assignmentsToAdd : [];
    });
    var fundAggregationsToAddLength = computed(function () {
      return props.syncState && props.syncState.fundAggregationsToAdd && props.syncState.fundAggregationsToAdd.length ? props.syncState.fundAggregationsToAdd.length : 0;
    });
    var fundAggregationsToAdd = computed(function () {
      return props.syncState && props.syncState.fundAggregationsToAdd ? props.syncState.fundAggregationsToAdd : [];
    });
    var fundAggregationsToDeleteLength = computed(function () {
      return props.syncState && props.syncState.fundAggregationsToDelete && props.syncState.fundAggregationsToDelete.length ? props.syncState.fundAggregationsToDelete.length : 0;
    });
    var fundAggregationsToDelete = computed(function () {
      return props.syncState && props.syncState.fundAggregationsToDelete ? props.syncState.fundAggregationsToDelete : [];
    });
    function getModulesToAddText(item) {
      return item && item.modulesToAdd && Array.isArray(item.modulesToAdd) ? item.modulesToAdd.join(', ') : '';
    }
    function isHiddenKpi(item) {
      var fund = props.fund;
      return !!(fund && fund.portfolio && fund.portfolio.hiddenKpis && item && item.metricId != null && fund.portfolio.hiddenKpis.includes(item.metricId));
    }
    return {
      __sfc: true,
      props: props,
      moduleUpdatesLength: moduleUpdatesLength,
      moduleUpdates: moduleUpdates,
      esgQuestionnairesToAddLength: esgQuestionnairesToAddLength,
      esgQuestionnairesToAdd: esgQuestionnairesToAdd,
      assignmentsToAddLength: assignmentsToAddLength,
      assignmentsToAdd: assignmentsToAdd,
      fundAggregationsToAddLength: fundAggregationsToAddLength,
      fundAggregationsToAdd: fundAggregationsToAdd,
      fundAggregationsToDeleteLength: fundAggregationsToDeleteLength,
      fundAggregationsToDelete: fundAggregationsToDelete,
      getModulesToAddText: getModulesToAddText,
      isHiddenKpi: isHiddenKpi
    };
  }
});